import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import { defaultLanguage } from "../../constants";
import {
  accommodationFormDefaultDisplay,
  accFormDefaultEntries,
} from "../../languages/defaultEntries";
import CurrencyDropdown from "./CurrencyDropdown";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { SaveButton } from "../buttons/Buttons";

const WEBSITE_URL = "/dashboard";

export default function AccommodationList() {
  const art = defaultLanguage;
  const title = "accomodationForm";
  const { username } = useAuth();
  const { t } = useTranslation();
  const [canSave, setCanSave] = useState(false);

  const defaultDisplay = accommodationFormDefaultDisplay;
  const defaultEntry = accFormDefaultEntries;

  // const [loading, setLoading] = useState(true);
  const [isContentEmpty, setIsContentEmpty] = useState(false);

  const [accomodationType, setAccomodationType] = useState("-1");
  const [guests, setGuests] = useState(1);
  const [bedrooms, setBedrooms] = useState(1);
  const [bathrooms, setBathrooms] = useState(1);
  const [dogs, setDogs] = useState(false);
  const [wheelchair, setWheelchair] = useState(false);
  const [parking, setParking] = useState(false);
  const [childrenBed, setChildrenBed] = useState(false);
  const [evCharging, setEvcharging] = useState(false);
  const [bicycleParking, setBicycleParking] = useState(false);
  const [selfCheckIn, setSelfCheckIn] = useState(false);
  const [numNights, setnumNights] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [singleBeds, setSingleBeds] = useState(2);
  const [doubleBeds, setDoubleBeds] = useState(2);
  const [sofaBeds, setSofaBeds] = useState(2);
  const [checkIn, setCheckIn] = useState(-1);
  const [checkOut, setCheckOut] = useState(-1);
  const [wifi, setWifi] = useState(true);
  const [nameAccommodation, setNameAccommodation] = useState("");
  const [lowerPrice, setLowerPrice] = useState(0);
  const [higherPrice, setHigherPrice] = useState(0);
  const [cleaningIncluded, setCleaningIncluded] = useState(false);
  const [cityTaxIncluded, setcityTaxIncluded] = useState(false);
  const [cleaningService, setCleaningService] = useState("0");
  const [luggageService, setLuggageService] = useState("0");
  const [breakfastService, setBreakfastService] = useState("0");
  const [longStay, setLongStay] = useState("0");
  const [tc, setTC] = useState("0");
  const [currency, setCurrency] = useState("");
  const [meterSquared, setMeterSquared] = useState(-1);
  const [tourismOfficeLink, setTourismOfficeLink] = useState("");
  const [icalURL, setIcalURL] = useState("");
  const [homePageVideoURL, setHomePageVideoURL] = useState("");
  const [showSpecialOffers, setShowSpecialOffers] = useState(true);
  const [showPrices, setShowPrices] = useState(true);
  const [showBlogs, setShowBlogs] = useState(true);
  const [showFloorPlan, setShowFloorPlan] = useState(false);
  const [copyMsg, setCopyMsg] = useState("");
  const API_BASE = axios.defaults.baseURL;
  const exportUrl = `${API_BASE}/sync-ical/${username}.ics`;

  useEffect(() => {
    if (accomodationType !== "-1" && nameAccommodation && guests && bedrooms) {
      setCanSave(true);
    }
  }, [accomodationType, nameAccommodation, guests, bedrooms]);

  useEffect(() => {
    const getContent = async () => {
      try {
        const response = await axios.get(`${WEBSITE_URL}`, {
          params: { username, art, title },
        });
        if (response.data.entry) {
          setAccomodationType(response.data.entry.accomodationType);
          setGuests(response.data.entry.guests);
          setBedrooms(response.data.entry.bedrooms);
          setBathrooms(response.data.entry.bathrooms);
          setDogs(response.data.entry.dogs);
          setWheelchair(response.data.entry.wheelchair);
          setParking(response.data.entry.parking);
          setChildrenBed(response.data.entry.childrenBed);
          setEvcharging(response.data.entry.evCharging);
          setBicycleParking(response.data.entry.bicycleParking);
          setSelfCheckIn(response.data.entry.selfCheckIn);
          setnumNights(response.data.entry.numNights);
          setSingleBeds(response.data.entry.singleBeds);
          setDoubleBeds(response.data.entry.doubleBeds);
          setSofaBeds(response.data.entry.sofaBeds);
          setCheckIn(response.data.entry.checkIn);
          setCheckOut(response.data.entry.checkOut);
          setWifi(response.data.entry.wifi);
          setNameAccommodation(response.data.entry.nameAccommodation);
          setLowerPrice(response.data.entry.lowerPrice);
          setHigherPrice(response.data.entry.higherPrice);
          setCleaningIncluded(response.data.entry.cleaningIncluded);
          setcityTaxIncluded(response.data.entry.cityTaxIncluded);
          setCleaningService(response.data.entry.cleaningService);
          setBreakfastService(response.data.entry.breakfastService);
          setLuggageService(response.data.entry.luggageService);
          setLongStay(response.data.entry.longStay);
          setCurrency(response.data.entry.currency);
          setMeterSquared(response.data.entry.meterSquared);
          setTourismOfficeLink(response.data.entry.tourismOfficeLink);
          setIcalURL(response.data.entry.icalURL);
          setHomePageVideoURL(response.data.entry.homePageVideoURL);
          setShowSpecialOffers(response.data.entry.showSpecialOffers);
          setShowPrices(response.data.entry.showPrices ?? true);
          setShowBlogs(response.data.entry.showBlogs);
          setShowFloorPlan(response.data.entry.showFloorPlan);
          setTC(response.data.entry.tc);
        }
        // setLoading(false);
      } catch (err) {
        console.log(err);
      }
    };
    getContent();
  }, [username, art, title]);

  const saveContent = async () => {
    try {
      const normalizedIcalURL = icalURL.split(/[\n,]+/).map(u => u.trim()).filter(Boolean).join(',');

      await axios.put(WEBSITE_URL, {
        username,
        art,
        title,
        accomodationType,
        guests,
        bedrooms,
        bathrooms,
        dogs,
        wheelchair,
        parking,
        childrenBed,
        evCharging,
        bicycleParking,
        selfCheckIn,
        numNights,
        singleBeds,
        doubleBeds,
        sofaBeds,
        checkIn,
        checkOut,
        wifi,
        nameAccommodation,
        lowerPrice,
        higherPrice,
        cityTaxIncluded,
        cleaningIncluded,
        cleaningService,
        luggageService,
        breakfastService,
        longStay,
        currency,
        meterSquared,
        tourismOfficeLink,
        icalURL: normalizedIcalURL,
        homePageVideoURL,
        showSpecialOffers,
        showPrices,
        showBlogs,
        showFloorPlan,
        tc,
      });
      setIsSubmitted(true);
      setIsContentEmpty(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSaveClick = (event) => {
    event.preventDefault();
    if (isContentEmpty) {
      alert("Error: Text cannot be empty!");
      return;
    }
    // Pass the updated reviews array to saveContent function
    saveContent();
  };

  const copyExportLink = async () => {
    try {
      await navigator.clipboard.writeText(exportUrl);
      setCopyMsg("Export link copied");
      setTimeout(() => setCopyMsg(""), 3000);
    } catch (e) {
      setCopyMsg("Copy failed — please copy manually");
      setTimeout(() => setCopyMsg(""), 3000);
    }
  };

  /*     const numberInputFields1 = {
            "guests": setGuests,
            "bedrooms": setBedrooms,
            "singleBeds": setSingleBeds,
            "doubleBeds": setDoubleBeds,
            "sofaBeds": setSofaBeds,
            "bathrooms": setBathrooms,
            "numNights": setnumNights
        }
    
        const numberInputFields2 = {
            "lowerPrice": setLowerPrice,
            "higherPrice": setHigherPrice,
        }
    
        const checkBoxFields1 = {
            "dogs": setDogs,
            "wheelchair": setWheelchair,
            "parking": setParking,
            "childrenBed": setChildrenBed,
            "selfCheckIn": setSelfCheckIn,
            "wifi": setWifi
        };
    
        const checkBoxFields2 = {
            "cleaningIncluded": setCleaningIncluded,
            "cityTaxIncluded": setcityTaxIncluded,
        }
    
        const CheckBoxFieldsMap = (obj) => {
            return (Object.keys(obj).map((key) => {
                return (
                    <div className="form-row">
                        <label className="form-label" htmlFor={key}>
                            {accommodationForm.key}
                            <input
                                type="checkbox" d
                                id={key}
                                value={key}
                                checked={key}
                                style={{ marginLeft: "10px" }}
                                onChange={(event) => obj[key](event.target.checked)}
                            />
                        </label>
                    </div>
                )
            }))
        } */

  return (
    <div>
      <form className="review-form">
        <h3> {t("dashboard_page.acc_form.title")} </h3>
        <div className="form-row">
          <label className="form-label" htmlFor="nameAccommodation">
            {t("dashboard_page.acc_form.nameAccommodation")}{" "}
          </label>
          <input
            type="text"
            id="nameAccommodation"
            value={
              nameAccommodation === defaultEntry.nameAccommodation
                ? defaultDisplay.nameAccommodation
                : nameAccommodation
            }
            placeholder={
              nameAccommodation === defaultEntry.nameAccommodation
                ? defaultDisplay.nameAccommodation
                : nameAccommodation
            }
            className={nameAccommodation ? "valid" : "invalid"}
            onChange={(event) => setNameAccommodation(event.target.value)}
          />
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="homePageVideoURL">
            YouTube Video URL:
          </label>
          <input
            type="text"
            id="homePageVideoURL"
            placeholder="https://www.youtube.com/watch?v=cWx7FPUVlOw"
            value={homePageVideoURL}
            onChange={(e) => setHomePageVideoURL(e.target.value)}
            style={{ width: "100%", maxWidth: "600px" }}
            className={homePageVideoURL ? "valid" : "invalid"}
          />
        </div>

        <div className="form-row">
          <label className="form-label" htmlFor="type">
            {t("dashboard_page.acc_form.type")}
          </label>
          <select
            id="type"
            value={
              t("codes.acc_types." + accomodationType) ===
              defaultEntry[t("codes.acc_types." + accomodationType)]
                ? defaultDisplay.t("codes.acc_types." + accomodationType)
                : t("codes.acc_types." + accomodationType)
            }
            onChange={(event) =>
              setAccomodationType(
                t("rev_codes.acc_types." + event.target.value)
              )
            }
            style={
              accomodationType !== "-1"
                ? {
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                  }
                : {
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid red",
                  }
            }
          >
            <option
              value={
                t("codes.acc_types." + accomodationType) ===
                defaultEntry[t("codes.acc_types." + accomodationType)]
                  ? defaultDisplay.t("codes.acc_types." + accomodationType)
                  : t("codes.acc_types." + accomodationType)
              }
            >
              {t("codes.acc_types." + accomodationType) ===
              defaultEntry[t("codes.acc_types." + accomodationType)]
                ? defaultDisplay.t("codes.acc_types." + accomodationType)
                : t("codes.acc_types." + accomodationType)}
            </option>
            {t("dashboard_page.acc_types", { returnObjects: true }).map(
              (type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="guests">
            {t("dashboard_page.acc_form.guests")}
          </label>
          <input
            type="number"
            id="guests"
            value={
              guests === defaultEntry.guests ? defaultDisplay.guests : guests
            }
            style={{ width: "75px" }}
            className={guests !== -1 ? "valid" : "invalid"}
            onChange={(event) => setGuests(event.target.value)}
          />
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="bedrooms">
            {t("dashboard_page.acc_form.bedrooms")}
          </label>
          <input
            type="number"
            id="bedrooms"
            value={
              bedrooms === defaultEntry.bedrooms
                ? defaultDisplay.bedrooms
                : bedrooms
            }
            style={{ width: "75px" }}
            className={bedrooms !== -1 ? "valid" : "invalid"}
            onChange={(event) => setBedrooms(event.target.value)}
          />
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="singleBeds">
            {t("dashboard_page.acc_form.singleBeds")}
          </label>
          <input
            type="number"
            id="singleBeds"
            value={
              singleBeds === defaultEntry.singleBeds
                ? defaultDisplay.singleBeds
                : singleBeds
            }
            style={{ width: "75px", marginRight: "10px" }}
            className="form-input"
            onChange={(event) => setSingleBeds(event.target.value)}
          />
          <label className="form-label" htmlFor="doubleBeds">
            {t("dashboard_page.acc_form.doubleBeds")}
          </label>
          <input
            type="number"
            id="doubleBeds"
            style={{ width: "75px", marginRight: "10px" }}
            value={
              doubleBeds === defaultEntry.doubleBeds
                ? defaultDisplay.doubleBeds
                : doubleBeds
            }
            className="form-input"
            onChange={(event) => setDoubleBeds(event.target.value)}
          />
          <label className="form-label" htmlFor="sofaBeds">
            {t("dashboard_page.acc_form.sofaBeds")}
          </label>
          <input
            type="number"
            id="sofaBeds"
            value={
              sofaBeds === defaultEntry.sofaBeds
                ? defaultDisplay.sofaBeds
                : sofaBeds
            }
            style={{ width: "75px" }}
            className="form-input"
            onChange={(event) => setSofaBeds(event.target.value)}
          />
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="bathrooms">
            {t("dashboard_page.acc_form.bathrooms")}
          </label>
          <input
            type="number"
            id="bathroom"
            value={
              bathrooms === defaultEntry.bathrooms
                ? defaultDisplay.bathrooms
                : bathrooms
            }
            className={bathrooms ? "valid" : "invalid"}
            style={{ width: "75px" }}
            onChange={(event) => setBathrooms(event.target.value)}
          />
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="numNights">
            {t("dashboard_page.acc_form.numNights")}
          </label>
          <input
            type="number"
            id="numNights"
            value={
              numNights === defaultEntry.numNights
                ? defaultDisplay.numNights
                : numNights
            }
            style={{ width: "75px" }}
            onChange={(event) => setnumNights(event.target.value)}
          />
        </div>
        <div className="form-row">
          <label
            className="form-label"
            htmlFor="dogs"
            style={{ display: "flex", alignItems: "center" }}
          >
            {t("dashboard_page.acc_form.dogs")}
            <input
              type="checkbox"
              id="dogs"
              checked={dogs}
              value={dogs}
              style={{ marginLeft: "10px", width: "auto" }}
              onChange={(event) => setDogs(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label
            className="form-label"
            htmlFor="wheelchair"
            style={{ display: "flex", alignItems: "center" }}
          >
            {t("dashboard_page.acc_form.wheelchair")}
            <input
              type="checkbox"
              id="wheelchair"
              checked={wheelchair}
              value={wheelchair}
              style={{ marginLeft: "10px", width: "auto" }}
              onChange={(event) => setWheelchair(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label
            className="form-label"
            htmlFor="parking"
            style={{ display: "flex", alignItems: "center" }}
          >
            {t("dashboard_page.acc_form.parking")}
            <input
              type="checkbox"
              id="parking"
              value={parking}
              checked={parking}
              style={{ marginLeft: "10px", width: "auto" }}
              onChange={(event) => setParking(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label
            className="form-label"
            htmlFor="childrenBed"
            style={{ display: "flex", alignItems: "center" }}
          >
            {t("dashboard_page.acc_form.childrenBed")}
            <input
              type="checkbox"
              id="childrenBed"
              value={childrenBed}
              checked={childrenBed}
              style={{ marginLeft: "10px", width: "auto" }}
              onChange={(event) => setChildrenBed(event.target.checked)}
            />
          </label>
        </div>

        <div className="form-row">
          <label
            className="form-label"
            htmlFor="evCharging"
            style={{ display: "flex", alignItems: "center" }}
          >
            {t("dashboard_page.acc_form.evCharging")}
            <input
              type="checkbox"
              id="evCharging"
              value={evCharging}
              checked={evCharging}
              style={{ marginLeft: "10px", width: "auto" }}
              onChange={(event) => setEvcharging(event.target.checked)}
            />
          </label>
        </div>

        <div className="form-row">
          <label
            className="form-label"
            htmlFor="bicycleParking"
            style={{ display: "flex", alignItems: "center" }}
          >
            {t("dashboard_page.acc_form.bicycleParking")}
            <input
              type="checkbox"
              id="bicycleParking"
              value={bicycleParking}
              checked={bicycleParking}
              style={{ marginLeft: "10px", width: "auto" }}
              onChange={(event) => setBicycleParking(event.target.checked)}
            />
          </label>
        </div>

        <div className="form-row">
          <label className="form-label" htmlFor="selfCheckIn">
            {t("dashboard_page.acc_form.selfCheckIn")}
            <input
              type="checkbox"
              id="selfCheckIn"
              value={selfCheckIn}
              checked={selfCheckIn}
              style={{ marginLeft: "10px" }}
              onChange={(event) => setSelfCheckIn(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="wifi">
            {t("dashboard_page.acc_form.wifi")}
            <input
              type="checkbox"
              id="wifi"
              value={wifi}
              checked={wifi}
              style={{ marginLeft: "10px" }}
              onChange={(event) => setWifi(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label
            className="form-label"
            htmlFor="checkIn"
            style={{ display: "flex", alignItems: "center" }}
          >
            {t("dashboard_page.acc_form.checkIn")}
            <input
              type="time"
              id="checkIn"
              value={
                checkIn === defaultEntry.checkIn
                  ? defaultDisplay.checkIn
                  : checkIn
              }
              style={{ marginLeft: "10px", width: "auto" }}
              onChange={(event) => setCheckIn(event.target.value)}
            />
          </label>
          <label
            className="form-label"
            htmlFor="checkOut"
            style={{ display: "flex", alignItems: "center" }}
          >
            {t("dashboard_page.acc_form.checkOut")}
            <input
              type="time"
              id="checkOut"
              value={
                checkOut === defaultEntry.checkOut
                  ? defaultDisplay.checkOut
                  : checkOut
              }
              style={{ marginLeft: "10px", width: "auto" }}
              onChange={(event) => setCheckOut(event.target.value)}
            />
          </label>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="cleaningIncluded">
            {t("dashboard_page.acc_form.cleaningIncluded")}
            <input
              type="checkbox"
              id="cleaningIncluded"
              value={cleaningIncluded}
              checked={cleaningIncluded}
              style={{ marginLeft: "10px" }}
              onChange={(event) => setCleaningIncluded(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="cityTaxIncluded">
            {t("dashboard_page.acc_form.cityTaxIncluded")}
            <input
              type="checkbox"
              id="cityTaxIncluded"
              value={cityTaxIncluded}
              checked={cityTaxIncluded}
              style={{ marginLeft: "10px" }}
              onChange={(event) => setcityTaxIncluded(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="showSpecialOffers">
            {t("dashboard_page.acc_form.showSpecialOffers")}
            <input
              type="checkbox"
              id="showSpecialOffers"
              value={showSpecialOffers}
              checked={showSpecialOffers}
              style={{ marginLeft: "10px" }}
              onChange={(event) => setShowSpecialOffers(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="showPrices">
            {t("dashboard_page.acc_form.showPrices")}
            <input
              type="checkbox"
              id="showPrices"
              value={showPrices}
              checked={showPrices}
              style={{ marginLeft: "10px" }}
              onChange={(event) => setShowPrices(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="showBlogs">
            {t("dashboard_page.acc_form.showBlogs")}
            <input
              type="checkbox"
              id="showBlogs"
              value={showBlogs}
              checked={showBlogs}
              style={{ marginLeft: "10px" }}
              onChange={(event) => setShowBlogs(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="showFloorPlan">
            {t("dashboard_page.acc_form.showFloorPlan")}
            <input
              type="checkbox"
              id="showFloorPlan"
              value={showFloorPlan}
              checked={showFloorPlan}
              style={{ marginLeft: "10px" }}
              onChange={(event) => setShowFloorPlan(event.target.checked)}
            />
          </label>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="tourismOfficeLink">
            {t("dashboard_page.acc_form.tourismOfficeLink")}{" "}
          </label>
          <input
            type="text"
            style={{ width: "300px", marginRight: "10px" }}
            id="tourismOfficeLink"
            value={
              tourismOfficeLink === defaultEntry.tourismOfficeLink
                ? defaultDisplay.tourismOfficeLink
                : tourismOfficeLink
            }
            className={tourismOfficeLink ? "valid" : "invalid"}
            onChange={(event) => setTourismOfficeLink(event.target.value)}
          />
        </div>

        <div className="form-row">
          <label className="form-label" htmlFor="lowerPrice">
            {t("dashboard_page.acc_form.lowerPrice")}
          </label>
          <input
            type="number"
            id="lowerPrice"
            style={{ width: "100px", marginRight: "10px" }}
            value={
              lowerPrice === defaultEntry.lowerPrice
                ? defaultDisplay.lowerPrice
                : lowerPrice
            }
            className={lowerPrice ? "valid" : "invalid"}
            onChange={(event) => setLowerPrice(event.target.value)}
          />
          <label className="form-label" htmlFor="higherPrice">
            {t("dashboard_page.acc_form.higherPrice")}
          </label>
          <input
            type="number"
            id="higherPrice"
            style={{ width: "100px", marginRight: "10px" }}
            value={
              higherPrice === defaultEntry.higherPrice
                ? defaultDisplay.higherPrice
                : higherPrice
            }
            className={higherPrice ? "valid" : "invalid"}
            onChange={(event) => setHigherPrice(event.target.value)}
          />
          <CurrencyDropdown setCurrency={setCurrency} />
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="type">
            {t("dashboard_page.acc_form.cleaningService")}
          </label>
          <select
            id="type"
            value={t("service_codes." + cleaningService)}
            onChange={(event) =>
              setCleaningService(t("rev_service_codes." + event.target.value))
            }
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              color: "#333",
            }}
          >
            <option value={t("service_codes." + cleaningService)}>
              {t("service_codes." + cleaningService)}
            </option>
            {t("dropdown.general", { returnObjects: true }).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="type">
            {t("dashboard_page.acc_form.luggageService")}
          </label>
          <select
            id="type"
            value={t("service_codes." + luggageService)}
            onChange={(event) =>
              setLuggageService(t("rev_service_codes." + event.target.value))
            }
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              color: "#333",
            }}
          >
            <option value={t("service_codes." + luggageService)}>
              {t("service_codes." + luggageService)}
            </option>
            {t("dropdown.general", { returnObjects: true }).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="type">
            {t("dashboard_page.acc_form.breakfast")}
          </label>
          <select
            id="type"
            value={t("service_codes." + breakfastService)}
            onChange={(event) =>
              setBreakfastService(t("rev_service_codes." + event.target.value))
            }
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              color: "#333",
            }}
          >
            <option value={t("service_codes." + breakfastService)}>
              {t("service_codes." + breakfastService)}
            </option>
            {t("dropdown.breakfast", { returnObjects: true }).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="type">
            {t("dashboard_page.acc_form.longStay")}
          </label>
          <select
            id="type"
            value={t("service_codes." + longStay)}
            onChange={(event) =>
              setLongStay(t("rev_service_codes." + event.target.value))
            }
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              color: "#333",
            }}
          >
            <option value={t("service_codes." + longStay)}>
              {t("service_codes." + longStay)}
            </option>
            {t("dropdown.general", { returnObjects: true }).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        <div className="form-row">
          <label className="form-label" htmlFor="tc">
            {t("dashboard_page.acc_form.TC")}
          </label>
          <select
            id="tc"
            value={tc}
            onChange={(event) => setTC(event.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              backgroundColor: "#f5f5f5",
              color: "#333",
            }}
          >
            {Object.entries(t("tc_service_codes", { returnObjects: true })).map(
              ([label, code]) => (
                <option key={code} value={code}>
                  {t("services." + label) || label}
                </option>
              )
            )}
          </select>
        </div>

        <div className="form-row">
          <label className="form-label" htmlFor="meterSquared">
            {t("dashboard_page.acc_form.meter")}
          </label>
          <input
            type="number"
            id="meterSquared"
            value={
              meterSquared === defaultEntry.meterSquared
                ? defaultDisplay.meterSquared
                : meterSquared
            }
            style={{ width: "75px" }}
            onChange={(event) => setMeterSquared(event.target.value)}
          />
        </div>
        <div style={{ marginTop: "30px", marginBottom: "10px" }}>
          <h4 style={{ margin: 0 }}>
            Third Party Synchronisation{" "}
            <span
              style={{
                fontSize: "0.8em",
                fontWeight: "normal",
              }}
            >
              (if applicable)
            </span>
          </h4>
        </div>

        <div className="form-row">
          <label className="form-label" htmlFor="icalURL">
            {t("dashboard_page.acc_form.icalURL")}
          </label>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {icalURL
              .split(",")
              .map((url, index) => url.trim())
              .filter(Boolean)
              .concat(
                icalURL.trim().endsWith(",") || icalURL === "" ? [""] : []
              )
              .map((url, index, arr) => (
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="text"
                    id={`icalURL-${index}`}
                    value={url}
                    placeholder={`https://www.airbnb.com/calendar/ical/...`}
                    onChange={(e) => {
                      const urls = icalURL
                        .split(",")
                        .map((u) => u.trim())
                        .filter(Boolean);
                      urls[index] = e.target.value;
                      setIcalURL(urls.join(","));
                    }}
                    style={{
                      width: "100%",
                      maxWidth: "600px",
                      marginRight: "10px",
                      padding: "8px",
                    }}
                    className={url ? "valid" : "invalid"}
                  />
                  {arr.length > 1 && (
                    <button
                      type="button"
                      onClick={() => {
                        const urls = icalURL
                          .split(",")
                          .map((u) => u.trim())
                          .filter(Boolean);
                        urls.splice(index, 1);
                        setIcalURL(urls.join(","));
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "red",
                        fontSize: "18px",
                        cursor: "pointer",
                      }}
                    >
                      −
                    </button>
                  )}
                </div>
              ))}

            <button
              type="button"
              onClick={() => {
                const trimmed = icalURL.trim();
                setIcalURL(trimmed ? trimmed + "," : "");
              }}
              style={{
                background: "none",
                border: "1px solid #ccc",
                borderRadius: "5px",
                padding: "4px 10px",
                cursor: "pointer",
                color: "#007bff",
                width: "fit-content",
              }}
            >
              + Add Calendar
            </button>
          </div>
        </div>

        <div
          className="form-row"
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
            marginTop: "16px",
          }}
        >
          <label
            className="form-label"
            style={{
              minWidth: "180px",
              paddingTop: "6px",
              whiteSpace: "nowrap",
            }}
          >
          Export Calendar URL:
          </label>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
              maxWidth: "720px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <input
                type="text"
                value={exportUrl}
                readOnly
                style={{
                  flex: 1,
                  minWidth: "280px",
                  maxWidth: "600px",
                  padding: "8px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  backgroundColor: "#fff",
                }}
              />

              <button
                type="button"
                onClick={copyExportLink}
                style={{
                  padding: "8px 14px",
                  borderRadius: "6px",
                  border: "1px solid #0000004c",
                  backgroundColor: "#1a7f37",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  e.currentTarget.style.color = "#000000";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#f5f5f500";
                }}
              >
                Copy
              </button>
            </div>

            <div
              style={{
                color: "#666666",
                lineHeight: 1.4,
                maxWidth: "720px",
              }}
            >
              Copy this link and paste it in{" "}
              <b>Airbnb → Calendar → Availability → Sync calendars → Import calendar</b>.
              Updates can take up to <b>3 hours</b> to appear.
            </div>

            {!!copyMsg && (
              <div
                style={{
                  color: "#1a7f37",
                  backgroundColor: "#e9f7ef",
                  border: "1px solid #b7e2c3",
                  padding: "8px 10px",
                  borderRadius: "6px",
                  width: "fit-content",
                }}
              >
                {copyMsg}
              </div>
            )}
          </div>
        </div>

        <SaveButton
          buttonText={t("button.save")}
          onClick={handleSaveClick}
          enabled={canSave}
        />
        {!canSave && <p className="error-msg">{t("errors.fieldRequired")}</p>}
        {isSubmitted && <p>{t("dashboard_page.acc_form.successmsg")}</p>}
      </form>
    </div>
  );
}
